/*
 * SonarQube
 * Copyright (C) 2009-2025 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import { AxiosError } from 'axios';
import { addGlobalErrorMessage } from '../../design-system';
import handleRequiredAuthentication from '../../helpers/handleRequiredAuthentication';
import { HttpStatus, parseError } from '../../helpers/request';

interface ThrowGlobalErrorOptions {
  redirectUnauthorizedNoReasons?: boolean;
  returnErrorReasons?: boolean; // used only in SC
}

export function throwGlobalError(
  param: AxiosError | Response | any,
  options: ThrowGlobalErrorOptions = {},
): Promise<never> {
  if (param.response instanceof Response) {
    /* eslint-disable-next-line no-console */
    console.warn('DEPRECATED: response should not be wrapped, pass it directly.');
    param = param.response;
  }

  if (param instanceof Response) {
    return parseError(param)
      .then(
        (...args) => {
          addGlobalErrorMessage(...args);
          if (options.redirectUnauthorizedNoReasons && param.status === HttpStatus.Unauthorized) {
            handleRequiredAuthentication();
          }
        },
        () => {
          /* ignore parsing errors */
        },
      )
      .then(() => Promise.reject(param));
  }

  // Axios response object
  if (param.data?.message) {
    addGlobalErrorMessage(param.data?.message);

    return Promise.reject(param);
  }

  return Promise.reject(param);
}
